module.exports = __webpack_public_path__ + "img/course2.98e23f0b.png";